(() => {
  'use strict';

  const sendGlobal = (eventName, parameters = {}) => {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', eventName, parameters);
  };

  const aiSources = [
    { name: 'chatgpt', pattern: /chatgpt\.com|chat\.openai\.com|openai\.com/i },
    { name: 'gemini', pattern: /gemini\.google\.com|bard\.google\.com/i },
    { name: 'copilot', pattern: /copilot\.microsoft\.com|bing\.com\/chat/i },
    { name: 'perplexity', pattern: /perplexity\.ai/i },
    { name: 'claude', pattern: /claude\.ai/i },
    { name: 'poe', pattern: /poe\.com/i },
    { name: 'you', pattern: /you\.com/i }
  ];

  const referrer = document.referrer || '';
  const aiReferral = aiSources.find((source) => source.pattern.test(referrer));
  if (aiReferral) {
    try {
      sessionStorage.setItem('gcr_ai_referral_source', aiReferral.name);
    } catch (_) {
      // Analytics must never interrupt the storefront.
    }

    sendGlobal('ai_referral_session', {
      ai_source: aiReferral.name,
      landing_page: window.location.pathname
    });
  }

  const rememberedAiSource = (() => {
    try {
      return sessionStorage.getItem('gcr_ai_referral_source') || '';
    } catch (_) {
      return '';
    }
  })();

  const pageParameters = rememberedAiSource ? { ai_source: rememberedAiSource } : {};

  document.addEventListener('gcr:analytics', (event) => {
    const detail = event instanceof CustomEvent ? event.detail : null;
    const eventName = detail && typeof detail.eventName === 'string' ? detail.eventName : '';
    if (!/^[a-z0-9_]+$/.test(eventName)) return;
    const parameters = detail.parameters && typeof detail.parameters === 'object'
      ? detail.parameters
      : {};
    sendGlobal(eventName, {
      source_path: window.location.pathname,
      ...pageParameters,
      ...parameters
    });
  });

  if (window.location.pathname.startsWith('/products/')) {
    sendGlobal('product_page_view', {
      product_path: window.location.pathname,
      ...pageParameters
    });
  } else if (/^\/blogs\/[^/]+\/[^/]+/.test(window.location.pathname)) {
    sendGlobal('supporting_article_view', {
      article_path: window.location.pathname,
      ...pageParameters
    });
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const destination = new URL(link.href, window.location.origin);
    if (destination.origin !== window.location.origin || !destination.pathname.startsWith('/products/')) return;
    if (destination.pathname === window.location.pathname) return;
    if (link.hasAttribute('data-gcr-event')) return;

    sendGlobal('paid_product_click', {
      destination_path: destination.pathname,
      source_path: window.location.pathname,
      ...pageParameters
    });
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-gcr-event]');
    if (!link) return;
    const destination = new URL(link.href, window.location.origin);
    const contextualParameters = {};
    if (link.dataset.gcrJourney) contextualParameters.journey = link.dataset.gcrJourney.slice(0, 80);
    if (link.dataset.gcrDestinationType) contextualParameters.destination_type = link.dataset.gcrDestinationType.slice(0, 80);
    sendGlobal(link.dataset.gcrEvent || 'gcr_navigation_click', {
      destination_path: destination.pathname + destination.hash,
      source_path: window.location.pathname,
      link_text: (link.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 120),
      ...contextualParameters,
      ...pageParameters
    });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const action = new URL(form.action || window.location.href, window.location.origin);
    if (!action.pathname.includes('/cart/add')) return;

    sendGlobal('add_to_cart_intent', {
      product_path: window.location.pathname,
      ...pageParameters
    });
  }, true);

  const toolRoot = document.querySelector('[data-gcr-tool]');
  if (!toolRoot) return;

  const calculatorName = toolRoot.dataset.gcrTool || 'unknown';
  if (calculatorName === 'hub') return;

  const form = toolRoot.querySelector('.gcr-panel form');
  const results = toolRoot.querySelector('.gcr-results');
  const status = results && results.querySelector('[data-status]');
  const printButton = results && results.querySelector('[data-print]');
  let started = false;

  const send = (eventName, extra = {}) => {
    sendGlobal(eventName, {
      calculator_name: calculatorName,
      calculator_page: window.location.pathname,
      ...pageParameters,
      ...extra
    });
  };

  if (form) {
    const start = () => {
      if (started) return;
      started = true;
      send('calculator_start');
    };

    form.addEventListener('input', start, { passive: true });
    form.addEventListener('change', start, { passive: true });
    form.addEventListener('invalid', () => {
      send('calculator_validation_error');
    }, true);

    form.addEventListener('submit', () => {
      window.setTimeout(() => {
        const message = status ? status.textContent.trim() : '';
        const hasResult = results && Array.from(results.querySelectorAll('[data-out]'))
          .some((node) => {
            const value = node.textContent.trim();
            return value && value !== '—';
          });
        if (hasResult) {
          send('calculator_result', {
            result_status: /over|exceed|not ready|check|limit/i.test(message)
              ? 'attention'
              : 'result_shown'
          });
        }
      }, 0);
    });
  }

  if (printButton) {
    printButton.addEventListener('click', () => send('calculator_print'));
  }
})();
